import * as React from "react";

import {
  type FileItem,
  useFileUploadContext,
} from "../contexts/FileUploadContext";

import { usePollDocumentsFeed } from "./useFeedPolling";

import type { BoardDocument } from "./useFetchFeed";

export const usePollAttachmentsStatus = (
  attachments: FileItem[],
  attachmentFeedId?: string
) => {
  const { dispatch } = useFileUploadContext();

  const callback = React.useCallback(
    (documents: BoardDocument[]) => {
      for (const document of documents) {
        dispatch({
          type: "UPDATE_STATUS_OF_ATTACHMENTS",
          payload: {
            fileIds: [document.id],
            status:
              document.status === "COMPLETED"
                ? "COMPLETED"
                : document.status === "FAILED"
                  ? "PROCESSING_ERROR"
                  : "PROCESSING",
          },
        });
      }
    },
    [dispatch]
  );

  const { startPolling, stopPolling, pollingEnabled } = usePollDocumentsFeed(
    attachmentFeedId as string,
    callback
  );

  const areFilesProcessing = React.useMemo(() => {
    return attachments.some((file) => file.status === "PROCESSING");
  }, [attachments]);

  React.useEffect(() => {
    if (areFilesProcessing && attachmentFeedId && !pollingEnabled) {
      startPolling();
    } else if (!areFilesProcessing && pollingEnabled) {
      stopPolling();
    }
  }, [
    pollingEnabled,
    areFilesProcessing,
    attachmentFeedId,
    startPolling,
    stopPolling,
  ]);

  return null;
};
